module.exports = __webpack_public_path__ + "media/images/file-icons/64/003-interface-fdb2f5249bb5d10018cdce0e705ec7f1.png";